const news = {
  namespaced: true,
  state: {
    currentNews: null
  },
  getters: {
    currentNews: (state) => state.currentNews
  },
  mutations: {
    changeCurrentNews(state, news2) {
      var _a;
      if ((_a = this.$i18n) == null ? void 0 : _a.locale) {
        news2.locale = this.$i18n.locale;
      }
      state.currentNews = news2;
    }
  },
  actions: {
    changeCurrentNews({ commit }, News) {
      commit("changeCurrentNews", News);
    }
  }
};
export {
  news as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmV3cy5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3N0b3JlL25ld3MuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xuICAgIG5hbWVzcGFjZWQ6IHRydWUsXG4gICAgc3RhdGU6IHtcbiAgICAgICAgY3VycmVudE5ld3M6IG51bGwsXG4gICAgfSxcbiAgICBnZXR0ZXJzOiB7XG4gICAgICAgIGN1cnJlbnROZXdzOiAoc3RhdGUpID0+IHN0YXRlLmN1cnJlbnROZXdzLFxuICAgIH0sXG4gICAgbXV0YXRpb25zOiB7XG4gICAgICAgIGNoYW5nZUN1cnJlbnROZXdzKHN0YXRlLCBuZXdzKSB7XG4gICAgICAgICAgICBpZiAodGhpcy4kaTE4bj8ubG9jYWxlKSB7XG4gICAgICAgICAgICAgICAgbmV3cy5sb2NhbGUgPSB0aGlzLiRpMThuLmxvY2FsZVxuICAgICAgICAgICAgfVxuICAgICAgICAgICAgc3RhdGUuY3VycmVudE5ld3MgPSBuZXdzXG4gICAgICAgIH1cbiAgICB9LFxuICAgIGFjdGlvbnM6IHtcbiAgICAgICAgY2hhbmdlQ3VycmVudE5ld3MoeyBjb21taXQgfSwgTmV3cykge1xuICAgICAgICAgICAgY29tbWl0KCdjaGFuZ2VDdXJyZW50TmV3cycsIE5ld3MpXG4gICAgICAgIH1cbiAgICB9LFxufTtcbiJdLCJuYW1lcyI6WyJuZXdzIl0sIm1hcHBpbmdzIjoiQUFBQSxNQUFlLE9BQUE7QUFBQSxFQUNYLFlBQVk7QUFBQSxFQUNaLE9BQU87QUFBQSxJQUNILGFBQWE7QUFBQSxFQUNoQjtBQUFBLEVBQ0QsU0FBUztBQUFBLElBQ0wsYUFBYSxDQUFDLFVBQVUsTUFBTTtBQUFBLEVBQ2pDO0FBQUEsRUFDRCxXQUFXO0FBQUEsSUFDUCxrQkFBa0IsT0FBT0EsT0FBTTtBQVR2QztBQVVZLFdBQUksVUFBSyxVQUFMLG1CQUFZLFFBQVE7QUFDcEIsUUFBQUEsTUFBSyxTQUFTLEtBQUssTUFBTTtBQUFBLE1BQ3pDO0FBQ1ksWUFBTSxjQUFjQTtBQUFBLElBQ2hDO0FBQUEsRUFDSztBQUFBLEVBQ0QsU0FBUztBQUFBLElBQ0wsa0JBQWtCLEVBQUUsT0FBUSxHQUFFLE1BQU07QUFDaEMsYUFBTyxxQkFBcUIsSUFBSTtBQUFBLElBQzVDO0FBQUEsRUFDSztBQUNMOyJ9
